
import {
  EMPLOYEE_LOOKUP_PENDING,
  EMPLOYEE_LOOKUP_SUCCESS,
  EMPLOYEE_LOOKUP_FAIL,
  SET_MESSAGE,
} from "../types";
import UserService from "../../services/user.service";

export const getEmployeeLookup = () => async (dispatch) => {
  dispatch({
    type: EMPLOYEE_LOOKUP_PENDING,
    payload: { lookups: "isLoading" },
  });

  return await UserService.getEmployeeLookup()
    .then((response) => {
      const data = response.data;

      if (data.status && data.result?.length > 0) {
        const result = data.result[0];

        const normalized = {
          departments: result.departments || [],
          designations: result.designations || [],
          teams: result.teams || [],
          cities: result.cities || [],
          roles: result.roles || [],
          inactiveEmployees: result.inactiveEmployees || [],
          employmentStatuses: result.employmentStatuses || [],
          officeLocations: result.officeLocations || [],
          genders: result.genders || [],
        };

        dispatch({
          type: EMPLOYEE_LOOKUP_SUCCESS,
          payload: { lookups: normalized },
        });
      } else {
        dispatch({ type: EMPLOYEE_LOOKUP_FAIL });
      }

      return Promise.resolve();
    })
    .catch((error) => {
      const message =
        (error.response?.data?.message) ||
        error.message ||
        error.toString();

      dispatch({ type: EMPLOYEE_LOOKUP_FAIL });
      dispatch({ type: SET_MESSAGE, payload: message });

      return Promise.reject();
    });
};
